module.exports = __webpack_public_path__ + "img/upload-iconW.ca5ba97f.svg";